import { msg } from "@lit/localize";

import { NotaryEstimationWizardStep01PropertyValue } from "./steps/step01-property-value";
import { NotaryEstimationWizardStep02Result } from "./steps/step02-result";
import { IMAGES_MAP } from "../../common/images";
import { WizardVoidStep } from "../wizard/common-steps/void-step/wizard-void-step";
import { NotaryEstimationWizardStep03Sms } from "./steps/step03-sms";
import { WizardConfiguration } from "../wizard/wizard-configuration";
import { NotaryEstimationWizardNames } from "./notary-estimation-wizard-names";

export const NOTARY_ESTIMATION_WIZARD_CONFIGURATION = new WizardConfiguration(NotaryEstimationWizardNames.WizardName, {
	[NotaryEstimationWizardNames.Step01PropertyValue]: NotaryEstimationWizardStep01PropertyValue,
	[NotaryEstimationWizardNames.Step02Result]: NotaryEstimationWizardStep02Result,
	[NotaryEstimationWizardNames.Step03Sms]: NotaryEstimationWizardStep03Sms,
	thank_you: WizardVoidStep,
})
	.addStep({
		name: NotaryEstimationWizardNames.Step01PropertyValue,
		label: msg("Majetek"),
		headline: msg("Hodnota děděného majetku"),
		sidebarImage: IMAGES_MAP.stamp,
	})
	.addStep({
		name: NotaryEstimationWizardNames.Step02Result,
		label: msg("Výsledek"),
		headline: msg("Odměna notáře z dědictví"),
		canJumpForward: false,
	})
	.addStep({
		name: NotaryEstimationWizardNames.Step03Sms,
		label: msg("Ověření SMS"),
		headline: msg("Odhad tržní ceny Vaší nemovitosti"),
		canJumpForward: false,
	})
	.addStep({
		name: "thank_you",
		label: "Thank you",
		headline: "Thank you",
		canJumpForward: false,
	});
